import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { groupByLocation } from '../types/solution-participation-types';

@Injectable({
  providedIn: 'root'
})
export class SolutionPartService {

  private isExpandedSubject = new BehaviorSubject<boolean>(false);

  toggleAllGraphs(): void {
    const currentValue = this.isExpandedSubject.getValue();
    this.isExpandedSubject.next(!currentValue);    
  }

  getToggleObservable(): Observable<boolean> {
    return this.isExpandedSubject.asObservable();
  }

  extractProducts(data: groupByLocation[]) {
    const products = data.reduce((acc: any, curr) => {
      curr.productInfo.forEach((product) => {
        const existingProduct: any = acc.find(
          (productName: any) => productName === product.productName
        );

        if (!existingProduct) {
          // If a product with the product code doesn't exist, add it to the accumulator array
          acc.push(product.productName);
        }
      });

      return acc;
    }, []);
    return products;
  }


  searchProducts(searchKey: string, data: string[]) {
    let filteredArray = data.filter((element: any) =>
      element.toLowerCase().includes(searchKey.toLowerCase())
    )
    return filteredArray;
  }

  filterByProducts(selectedProducts: string[], data: groupByLocation[]) {
    const filteredData = data.filter((obj) => {
      if (obj.productInfo) {
        return obj.productInfo.some((product) =>
          selectedProducts.includes(product.productName)
        );
      }
      return false;
    });

    return filteredData;
  }
  

  filterByProductsLocationNonUsage(selectedProducts: string[], data: groupByLocation[]) {
    const filteredData = data.filter(obj => {
      return (!obj.productInfo.some(product => selectedProducts.includes(product.productName) || obj.productInfo.length==0));
    });

    return filteredData;
  }
}
